import { createSelector } from 'reselect'

import { selectPlanningWizardState } from './selectPlanningWizardState'

export const selectWizardSaveDisabled = createSelector(
  [selectPlanningWizardState],
  (planningWizard) => planningWizard.isSaveDisabled
)
